/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Keyword, ContentEditableDirective } from "../../../../directives/content-editable.directive";
import { Dialog } from "../../../../models/dialog";
import { Event } from "../../../../models/event";
import { KeywordService } from "../../../../services/keyword.service";
import { Component, OnInit, Input, ViewChild } from "@angular/core";


@Component({
  selector: 'app-dialog-message-editor',
  templateUrl: './dialog-message-editor.component.html'
})
export class DialogMessageEditorComponent implements OnInit {
  
  @Input()
  mDialog: Dialog;
  
  @Input()
  mUniqueIndex: number

  @Input()
  set event(event: Event) {
    console.log("SMS Editor - Set Event - Old Event: '" + this.mEvent + "', New Event: '" + event + "'");
    this.mEvent = event;
    this.mAvailableKeywords = this.mKeywordService.getAvailableKeywordsForEvent(this.mEvent);
  }

  mEvent: Event;
    
  @ViewChild(ContentEditableDirective)
  mMessageContent: ContentEditableDirective;

  //Keywords available to the Message Field
  mAvailableKeywords: Keyword[] = [];
  
  constructor(
    private mKeywordService: KeywordService
  ) { }
  
  
  ngOnInit(): void {
    
  }

  addKeyword(keyword: Keyword): boolean {
    this.mMessageContent.addKeyword(keyword);
    return false;
  }

  updateMessage(message: string): void {
    console.log("Updating Message: '" + message + "'");
    this.mDialog.message = message;
  }

}
